import { createAsyncThunk } from "@reduxjs/toolkit";
import { type KycCustomer } from "../../../domain/entities/kyc-customer";
import { type KycDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const loadCustomer = createAsyncThunk<
  KycCustomer,
  string,
  { dispatch: KycDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.LOAD_CUSTOMER, async (requestId, { extra }) => {
  return await extra.kycRepo.getCustomer(requestId);
});
